// import sub-components and assign them to the proper variables
var developer = require('./kd.api.data/kd.api.data.Developer')
var filter = require('./kd.api.data/kd.api.data.Filter')
var groupby = require('./kd.api.data/kd.api.data.GroupBy')
var page = require('./kd.api.data/kd.api.data.Page')
var request = require('./kd.api.data/kd.api.data.Request')
var sortorder = require('./kd.api.data/kd.api.data.SortOrder')

// these CamelCase variables correspond to what was originally kd.api.data.Xyz
var Developer = developer.Developer
var Filter = filter.Filter
var FilterItem = filter.FilterItem
var GroupBy = groupby.GroupBy
var GroupByList = groupby.GroupByList
var Page = page.Page
var Request = request.Request
var RequestItem = request.RequestItem
var SortOrder = sortorder.SortOrder
var SortOrderItem = sortorder.SortOrderItem

// map them back to api.data.Xyz (webpack provides the kd part) to preserve backward compatibility
var api = {
  data: {
    Developer: Developer,
    Filter: Filter,
    FilterItem: FilterItem,
    GroupBy: GroupBy,
    GroupByList: GroupByList,
    Page: Page,
    Request: Request,
    RequestItem: RequestItem,
    SortOrder: SortOrder,
    SortOrderItem: SortOrderItem
  }
}

// all kd.Xyz functions need to have implicit new to create new instance
// except for kd.Developer
exports.api = api
exports.Developer = Developer
exports.Filter = function () {
  return new Filter()
}
exports.FilterItem = function (entityTypeIn, propertyNameIn, filterDataTypeIn, filterOperatorIn, filterValuesIn) {
  return new FilterItem(entityTypeIn, propertyNameIn, filterDataTypeIn, filterOperatorIn, filterValuesIn)
}
exports.GroupBy = function (groupFunctionIn, entityTypeIn, propertyNameIn, dataTypeIn, sortDirectionIn, formatIn) {
  throw "GroupBy is deprecated use SelectItem for both Select and Group APIs";
  return new GroupBy(groupFunctionIn, entityTypeIn, propertyNameIn, dataTypeIn, sortDirectionIn, formatIn);
}
exports.SelectItem = function (groupFunctionIn, entityTypeIn, propertyNameIn, dataTypeIn, sortDirectionIn, formatIn) {
  return new GroupBy(groupFunctionIn, entityTypeIn, propertyNameIn, dataTypeIn, sortDirectionIn, formatIn);
}
exports.Page = function (startIn, rowsPerPageIn, resultCountIn) {
  return new Page(startIn, rowsPerPageIn, resultCountIn);
}
exports.Request = function (entityTypeIn, entityActionIn) {
  return new Request(entityTypeIn, entityActionIn);
}
exports.RequestItem = function (entityActionIn) {
  return new RequestItem(entityActionIn);
}
exports.SortOrder = function () {
  return new SortOrder();
}
exports.SortOrderItem = function (propertyNameIn, directionIn) {
  return new SortOrderItem(propertyNameIn, directionIn);
}



//////////////////
// WEBPACK FOOTER
// ./~/karmadata/kd.js
// module id = 197
// module chunks = 0